var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-icon-button",on:{"click":_vm.handleClick}},[_c('vx-tooltip',{attrs:{"text":_vm.tooltipSettings.text,"position":_vm.tooltipSettings.position}},[_c('div',{staticClass:"menu-icon cursor-pointer"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }